import { http } from '@/http/axios.js'

// 管理员列表
export function getAdminListAPI(params) {
  return http({
    url: `/adminapi/user/page`,
    method: 'get',
    params
  })
}
// 新增管理员
export function addAdminAPI(data) {
  return http({
    url: `/adminapi/user/add`,
    method: 'post',
    data
  })
}
// 编辑管理员
export function editAdminAPI(data) {
  return http({
    url: `/adminapi/user/edit`,
    method: 'post',
    data
  })
}
// 删除管理员
export function delAdminAPI(data) {
  return http({
    url: `/adminapi/user/delete`,
    method: 'post',
    data
  })
}
// 管理员详情
export function getAdminDetailAPI(params) {
  return http({
    url: `/adminapi/user/detail`,
    method: 'get',
    params
  })
}
// 角色列表
export function getRoleListAPI(params) {
  return http({
    url: '/adminapi/role/page',
    method: 'GET',
    params
  })
}
// 状态
export function editStatusAPI(data) {
  return http({
    url: '/adminapi/user/status',
    method: 'post',
    data
  })
}
// 部门树
export function getDeptTreeAPI() {
  return http({
    url: `/adminapi/dept/tree`,
    method: 'get'
  })
}